import {
  property,
  subclass,
} from "@arcgis/core/core/accessorSupport/decorators";
import { messageBundle, tsx } from "@arcgis/core/widgets/support/widget";
import Widget from "@arcgis/core/widgets/Widget";
import { VNode } from "src/interfaces/interfaces";

import { renderDescription, renderExamples } from "../../utils/appUtils";

import "./styles/AppTypeInfoModal.scss";
import { AppTypeInfoModalProperties } from "./support";

@subclass("Landing.widgets.AppTypeInfoModal")
export default class AppTypeInfoModal extends Widget {
  @property()
  picUrl: string;

  @property()
  appTypeTitle: string;

  @property()
  appTypeUrlFragment: string;

  @property()
  @messageBundle("dist/assets/t9n/App/App")
  appMessages;

  @property()
  sendFocusOnClose: Function;

  @property()
  portal: __esri.Portal;

  private _isActive: boolean = true;

  constructor(properties?: AppTypeInfoModalProperties) {
    super(properties);
  }

  render() {
    const { appDescriptions } = this.appMessages;

    const header = this._renderHeader();
    const descSection = renderDescription(
      this.appTypeUrlFragment,
      this.appMessages,
      this.portal
    );
    const exSection = renderExamples(
      this.appTypeUrlFragment,
      this.appMessages,
      this.portal
    );

    return (
      <calcite-dialog
        class="app-description-modal"
        open={this._isActive}
        modal={true}
        afterCreate={(modal: HTMLCalciteDialogElement) => {
          modal.setFocus();
          modal.addEventListener("calciteDialogClose", () => {
            this._close();
          });
        }}
        scale="m"
        width-scale="m"
        messageOverrides={{ close: appDescriptions.close }}
      >
        {header}

        <div class="app-description-modal__description">
          <img class="app-desc-image" src={this.picUrl} width="150px" alt="" />
          {descSection}
          {exSection}
        </div>

        <calcite-button
          id="close-btn"
          slot="footer-end"
          width="auto"
          scale="l"
          class="app-description-modal__close"
          onclick={() => {
            this._close();
          }}
        >
          {appDescriptions.close}
        </calcite-button>
      </calcite-dialog>
    );
  }

  private _close() {
    this._isActive = false;
    this.sendFocusOnClose?.();
    this.destroy();
  }

  private _renderHeader(): VNode {
    return (
      <h2 class="app-description-modal__header" slot="header-content">
        <div>{this.appTypeTitle}</div>
      </h2>
    );
  }
}
